module.exports = __webpack_public_path__ + "img/b58cfeb6b89ac5ff6b574ef71e75e8fb.png";